export default "__VITE_ASSET__ff903dee__"